module.exports = __webpack_public_path__ + "static/media/group-doctor2.bc8a9a84.png";